// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3oaiP","title":"ClientCherryInfo_title__1pFtR","itemText":"ClientCherryInfo_itemText__1AbJH"};